import Sider from "antd/es/layout/Sider";
import styled from "styled-components";

const sidebar = {
  bg: "#ffffff",
  text: "#030F1B",
  textMuted: "#030F1B",
  activeText: "#073b4c",
  activeBg: "#e8edf1",
  hoverBg: "#f4f6f8",
  icon: "#030F1B",
  activeIcon: "#073b4c",
  fontFamily: "'Inter', sans-serif",
  fontSize: "12px",
  lineHeight: "150%",
  fontWeight: 600,
  itemHeight: "40px",
  parentPaddingInline: "16px",
  childPaddingInline: "46px",
  iconSize: 20,
  childIconSize: 18,
  iconGap: "10px",
};

export const Wrapper = styled(Sider)`
  margin-inline-end: 0;
  background: ${sidebar.bg} !important;
  border-inline-end: 1px solid #edf2f7;
  overflow-y: auto;

  .sidebar-view {
    overflow: auto;
    overflow-x: hidden;
    min-height: 300px;
    height: calc(100vh - 220px);
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .sidebar-view::-webkit-scrollbar {
    display: none;
  }

  .sidebar-view:hover {
    scrollbar-width: auto;
  }

  .sidebar-view:hover::-webkit-scrollbar {
    display: block;
    width: 5px;
    background: #eee;
    border-radius: 10px;
  }

  .sidebar-view:hover::-webkit-scrollbar-thumb {
    background: #1971c2;
    border-radius: 10px;
  }

  .ant-menu {
    padding: 8px 0;
    background: ${sidebar.bg} !important;
    border-inline-end: none !important;
    font-family: ${sidebar.fontFamily};
  }

  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline .ant-menu-submenu-title {
    width: 100%;
    margin-inline: 0;
    margin-block: 2px;
    border-radius: 0;
    min-height: ${sidebar.itemHeight};
    height: ${sidebar.itemHeight};
    line-height: ${sidebar.itemHeight};
    padding-inline: ${sidebar.parentPaddingInline} !important;
    display: flex;
    align-items: center;
  }

  .ant-menu .ant-menu-item,
  .ant-menu .ant-menu-submenu-title {
    font-family: ${sidebar.fontFamily};
    font-size: ${sidebar.fontSize};
    font-weight: ${sidebar.fontWeight};
    line-height: ${sidebar.lineHeight};
    color: ${sidebar.text};
  }

  .ant-menu-item .ant-menu-item-icon,
  .ant-menu-submenu-title .ant-menu-item-icon {
    min-width: ${sidebar.iconSize}px;
    width: ${sidebar.iconSize}px;
    margin-inline-end: ${sidebar.iconGap} !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    color: ${sidebar.icon};
  }

  .sidebar-menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: inherit;
  }

  .ant-menu-item .ant-menu-title-content,
  .ant-menu-submenu-title .ant-menu-title-content {
    margin-inline-start: 0 !important;
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .ant-menu-item .ant-menu-title-content a,
  .ant-menu-submenu-title .ant-menu-title-content {
    font-family: ${sidebar.fontFamily};
    color: ${sidebar.text} !important;
    font-size: ${sidebar.fontSize};
    font-weight: ${sidebar.fontWeight};
    line-height: ${sidebar.lineHeight};
    display: flex;
    align-items: center;
  }

  .ant-menu-submenu-arrow {
    color: ${sidebar.textMuted} !important;
    inset-inline-end: 16px;
  }

  .ant-menu-item:not(.ant-menu-item-selected):hover,
  .ant-menu-submenu-title:hover {
    background: ${sidebar.hoverBg} !important;
    color: ${sidebar.text};
  }

  .ant-menu-light .ant-menu-item-selected,
  .ant-menu-light > .ant-menu .ant-menu-item-selected {
    background-color: ${sidebar.activeBg} !important;
    border-inline-start: none;
    color: ${sidebar.activeText};
  }

  .ant-menu-light .ant-menu-item-selected .ant-menu-title-content a {
    color: ${sidebar.activeText} !important;
    font-weight: ${sidebar.fontWeight};
  }

  .ant-menu-item-selected .ant-menu-item-icon,
  .ant-menu-item-selected .sidebar-menu-icon {
    color: ${sidebar.activeIcon} !important;
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: ${sidebar.text};
    font-weight: ${sidebar.fontWeight};
  }

  .ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: ${sidebar.bg} !important;
    padding-inline-start: 0 !important;

    .ant-menu-item {
      min-height: 36px;
      height: 36px;
      line-height: 36px;
      padding-inline: ${sidebar.childPaddingInline} ${sidebar.parentPaddingInline} !important;
      margin-block: 1px;
    }

    .ant-menu-item .ant-menu-item-icon {
      min-width: ${sidebar.childIconSize}px;
      width: ${sidebar.childIconSize}px;
      margin-inline-end: 8px !important;
      color: ${sidebar.textMuted};
    }

    .ant-menu-item .ant-menu-title-content a {
      font-family: ${sidebar.fontFamily};
      color: ${sidebar.text} !important;
      font-size: ${sidebar.fontSize};
      font-weight: ${sidebar.fontWeight};
      line-height: ${sidebar.lineHeight};
      display: flex;
      align-items: center;
    }

    .ant-menu-item-selected {
      background-color: ${sidebar.activeBg} !important;
    }

    .ant-menu-item-selected .ant-menu-title-content a {
      color: ${sidebar.activeText} !important;
      font-weight: ${sidebar.fontWeight};
    }

    .ant-menu-item-selected .ant-menu-item-icon,
    .ant-menu-item-selected .sidebar-menu-icon {
      color: ${sidebar.activeIcon} !important;
    }
  }

  .ant-menu-inline.ant-menu-root
    .ant-menu-submenu-title
    > .ant-menu-title-content {
    margin: 0 !important;
  }

  .app-sidebar-separator {
    border-bottom: 1px dashed #e2e8f0;
    margin: 0.75rem 0;
  }
`;

export const sidebarMenuIconClass = "sidebar-menu-icon";
